import { Component, OnInit } from '@angular/core';
import { DhukanDataService } from '../services/dhukan/dhukan-data.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from '../services/dhukan/login-data.service';
import { DatePipe } from '@angular/common';
declare var google;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
   isexport:boolean=false; 

   isloading:boolean=false;
   isprivilage:boolean=false;  
 showProgress:boolean=false;
   formname:String="Dashboard";

   
  neworders:number=0;
  newcustomer:number=0;
  totalorders:number=0;
  totalcustomer:number=0;

  placedcount:number=0;
  confirmcount:number=0;
  topackcount:number=0;
  readycount:number=0;
  assigncount:number=0;
  pickedcount:number=0;
  deliveredcount:number=0;
  cancelledcount:number=0;
  
  todaysales:number=0;
  todayvisitors:number=0;
  totalproducts:number=0;
  totalnodevice:number=0;

  recentviewers: number = 0;

  summaryColl:any=[];
  feedbackColl:any=[];
  mostviewproductsColl:any=[];
  ordersummaryColl:any=[];
  branchwiseColl:any=[];
  dailysalesColl: any = [];
  productrequestColl:any=[];
  dailysales: any[] = [];
  monthlywiseColl:any=[];
  billwiseColl:any[] = [];
  dailybillsales: any[] = [];
  openorderColl:any[]=[]

  areaColl:any[]=[]

  view: any[] = [500, 350];
  view1: any[] = [700, 300];
  // options
  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Year';
  yAxisLabel: string = 'Population';
  timeline: boolean = true;

  multi: any[];

  areaid:any=null

  
  constructor(private appService: DhukanDataService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,
    private loginService:LoginDataService,private datePipe: DatePipe) { 

      this.fnServiceChanges();
    }

    //User Check
    fnServiceChanges(){
      this.loginService.serviceloginChange.subscribe((value) => {
            if(this.loginService.fnCheckUser()){                
                this.fnCheckPrivilage();
                if(this.isview){
                  this.isloading=true;
                  this.fnOnInitForm();
                }
                else{
                  this.fnUserFailedForm();
                }    
            }
            else{
              this.fnUserFailedForm();
            }
      });
    }



    fnCheckPrivilage(){
      this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
      this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
      this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
      this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
      this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
      this.isexport=this.loginService.fnCheckUserRoleAction(this.formname,'EXPORT');
    }

    fnUserFailedForm(){
      this.isprivilage=true;
    }

    fnOnInitForm(){
      this.fngetArea();

      this.fngetDasboard();

      this.fnLoadGeoLocation();
  
     
    }

  ngOnInit() {
  
    if(this.loginService.fnCheckUser()){         
      this.fnCheckPrivilage();
      if(this.isview){
        this.isloading=true;
        this.fnOnInitForm();
      }
      else{
        this.fnUserFailedForm();
      }          
    }
    else{
      this.loginService.fnGetUserRoleList();
    }
    
  }


  fngetArea() {
    var data = {
      'areaid': 0,
    }
    this.appService.getArea(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            this.areaColl = res.json().result;
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetDasboard() { 

      var data = {
          'areaid':this.areaid
      }
      this.appService.fnGetDashboardAdmin(data)
      .subscribe(
        (res)=>{              
          if(res.json().status==200){                          
           var _res=res.json().result;

           this.summaryColl=_res[0];

           if(this.summaryColl.length>0){
            this.neworders=this.summaryColl[0].neworders;
            this.newcustomer=this.summaryColl[0].newcustomer;
            this.totalorders=this.summaryColl[0].totalorders;
            this.totalcustomer=this.summaryColl[0].totalcustomer;

            this.todaysales=this.summaryColl[0].todaysales;
            this.totalproducts=this.summaryColl[0].totalproducts;
            this.totalnodevice=this.summaryColl[0].totalnodevice;
             this.todayvisitors = this.summaryColl[0].todayvisitors;
             
             this.recentviewers= this.summaryColl[0].recentviewers;
           }

           this.feedbackColl=_res[1];
           this.mostviewproductsColl=_res[2];

            this.ordersummaryColl=_res[3];
           if(this.ordersummaryColl.length>0){
             this.placedcount = this.ordersummaryColl[0].placedcount;
             this.confirmcount = this.ordersummaryColl[0].confirmcount;             
             this.deliveredcount=this.ordersummaryColl[0].deliveredcount;
             this.cancelledcount=this.ordersummaryColl[0].cancelledcount;
           }
   
          //  this.branchwiseColl=_res[4];
           this.dailysalesColl = _res[4];
           this.dailysales = [];
           this.dailysales.push({"name": "Daily","series": this.dailysalesColl})
           
          
           this.productrequestColl= _res[5];
          //  this.monthlywiseColl = _res[7];
            
           this.billwiseColl = _res[6];
           this.dailybillsales = [];
           this.dailybillsales.push({"name": "Daily","series": this.billwiseColl})
           
          this.openorderColl= _res[7];

           console.log(this.dailysales)
            console.log(this.dailybillsales)
          }
          else if(res.json().status==400){                          
            this.toastr.error('Error', res.json().err_field);
          }                          
      },
        (err)=>{                        
          this.toastr.error('Error', err);
       })
  }

  fnEditCustomer(deptBO) {
    try {
      if (this.isedit) {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'id': deptBO.customerid,
          }
        }

        this.router.navigate(['/CustomerView'], navigationExtras);
      }

    } catch (ex) {
     // this.fnShowErrorMsg(ex);
    }
  }

  fnViewProductRequest() {
    try {
      this.router.navigate(['/ProductRequest']);      
    } catch (ex) {
     // this.fnShowErrorMsg(ex);
    }
  }

  fnViewFeedback() {
    try {
      this.router.navigate(['/FeedbackReport']);      
    } catch (ex) {
     // this.fnShowErrorMsg(ex);
    }
  }

  fnLoadGeoLocation(){

 
  }

    fnShowOrder(type) {
    try {
      if (this.isedit) {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'filterstatus': type,
            'areaid':this.areaid
          }
        }

        this.router.navigate(['/Orders'], navigationExtras);
      }

    } catch (ex) {
     // this.fnShowErrorMsg(ex);
    }
  }

}
